import { flow } from 'mobx-state-tree';

import { Lot } from '@common/models/lots/types';

import http from '@clientCommon/app/bootstrap/http';

import { API_BASE } from '@clientCommon/app/constants';
import { MODEL_ROUTE } from '../../constants';

type Query = {
  number?: string;
};

type Pagination = {
  offset: number;
  limit: number;
};

export default flow(function* (filterValue?: string, pagination?: Pagination) {
  const query = {} as Query;
  if (filterValue) {
    query.number = filterValue;
  }

  const response: { data: Lot[] } = yield http.get({
    url: `${API_BASE}${MODEL_ROUTE}`,
    query: {
      ...pagination,
      ...query,
    },
  });

  return response.data;
});
